"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignerAppFinalizeActionResponseToJSON = exports.SignerAppFinalizeActionResponseFromJSONTyped = exports.SignerAppFinalizeActionResponseFromJSON = exports.instanceOfSignerAppFinalizeActionResponse = exports.attributeTypeMapSignerAppFinalizeActionResponse = void 0;
exports.attributeTypeMapSignerAppFinalizeActionResponse = [
    {
        name: "isValid",
        type: "boolean",
    },
    {
        name: "isTrusted",
        type: "boolean",
    },
    {
        name: "writeBack",
        type: "boolean",
    },
    {
        name: "redirectUrl",
        type: "string",
    },
    {
        name: "qesUrl",
        type: "string",
    },
    {
        name: "eidProvider",
        type: "string",
    },
    {
        name: "eidProviderClientId",
        type: "string",
    },
    {
        name: "eidCountryCode",
        type: "string",
    },
    {
        name: "eidHasAdditionalSigningMethods",
        type: "boolean",
    },
    {
        name: "postsignPageType",
        type: "string",
    },
    {
        name: "cacheKey",
        type: "string",
    },
];
/**
 * Check if a given object implements the SignerAppFinalizeActionResponse interface.
 */
function instanceOfSignerAppFinalizeActionResponse(value) {
    if (!("isValid" in value) || value["isValid"] === undefined)
        return false;
    if (!("isTrusted" in value) || value["isTrusted"] === undefined)
        return false;
    if (!("writeBack" in value) || value["writeBack"] === undefined)
        return false;
    if (!("redirectUrl" in value) || value["redirectUrl"] === undefined)
        return false;
    return true;
}
exports.instanceOfSignerAppFinalizeActionResponse = instanceOfSignerAppFinalizeActionResponse;
function SignerAppFinalizeActionResponseFromJSON(json) {
    return SignerAppFinalizeActionResponseFromJSONTyped(json, false);
}
exports.SignerAppFinalizeActionResponseFromJSON = SignerAppFinalizeActionResponseFromJSON;
function SignerAppFinalizeActionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        isValid: json["is_valid"],
        isTrusted: json["is_trusted"],
        writeBack: json["write_back"],
        redirectUrl: json["redirect_url"],
        qesUrl: json["qes_url"] == null ? undefined : json["qes_url"],
        eidProvider: json["eid_provider"] == null ? undefined : json["eid_provider"],
        eidProviderClientId: json["eid_provider_client_id"] == null
            ? undefined
            : json["eid_provider_client_id"],
        eidCountryCode: json["eid_country_code"] == null ? undefined : json["eid_country_code"],
        eidHasAdditionalSigningMethods: json["eid_has_additional_signing_methods"] == null
            ? undefined
            : json["eid_has_additional_signing_methods"],
        postsignPageType: json["postsign_page_type"] == null
            ? undefined
            : json["postsign_page_type"],
        cacheKey: json["cache_key"] == null ? undefined : json["cache_key"],
    };
}
exports.SignerAppFinalizeActionResponseFromJSONTyped = SignerAppFinalizeActionResponseFromJSONTyped;
function SignerAppFinalizeActionResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        is_valid: value["isValid"],
        is_trusted: value["isTrusted"],
        write_back: value["writeBack"],
        redirect_url: value["redirectUrl"],
        qes_url: value["qesUrl"],
        eid_provider: value["eidProvider"],
        eid_provider_client_id: value["eidProviderClientId"],
        eid_country_code: value["eidCountryCode"],
        eid_has_additional_signing_methods: value["eidHasAdditionalSigningMethods"],
        postsign_page_type: value["postsignPageType"],
        cache_key: value["cacheKey"],
    };
}
exports.SignerAppFinalizeActionResponseToJSON = SignerAppFinalizeActionResponseToJSON;
